"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-input-group", {
    staticClass: "input-group"
  }, [_c("a-input", {
    staticStyle: {
      "border-right": "0"
    },
    attrs: {
      type: "number",
      min: 0,
      placeholder: "最小值"
    },
    model: {
      value: _vm.modelValue[0],
      callback: function ($$v) {
        _vm.$set(_vm.modelValue, 0, $$v);
      },
      expression: "modelValue[0]"
    }
  }), _c("a-input", {
    staticClass: "divider",
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input", {
    staticStyle: {
      "border-left": "0"
    },
    attrs: {
      type: "number",
      min: 0,
      placeholder: "最大值"
    },
    model: {
      value: _vm.modelValue[1],
      callback: function ($$v) {
        _vm.$set(_vm.modelValue, 1, $$v);
      },
      expression: "modelValue[1]"
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;